import React, { useState } from "react";
import { Tag, Button, Modal, message } from "antd";
import { FormOutlined, CloseOutlined, CheckCircleOutlined, SaveOutlined } from "@ant-design/icons";
import { EstadoVistaColaboradorFormulario as EstadoVistaColaborador } from "enum/EstadoVistaColaboradorFormulario";
import { useAtom } from "jotai";
import { useFormContext } from "react-hook-form";
import DetalleEnvioService from "services/DetalleEnvioService";
import {
	erroresFormularioAtom,
	formularioSeleccionadoAtom,
	permiteGuardarAvanceAtom,
	visibleVisorFormularioAtom
} from "pages/consultar/bandeja-tareas/store/Store";

const Header = ({ loadingPdf, onCompletado }) => {
	const [formularioSeleccionado] = useAtom(formularioSeleccionadoAtom);
	const [permiteGuardarAvance] = useAtom(permiteGuardarAvanceAtom);
	const [, setVisibleVisorFormulario] = useAtom(visibleVisorFormularioAtom);
	const [, setErroresFormulario] = useAtom(erroresFormularioAtom);
	const [guardando, setGuardando] = useState(false);
	const { handleSubmit, getValues } = useFormContext();

	const onClickBtnCerrar = () => {
		setVisibleVisorFormulario(false);
	};

	const mensajeError = (error, mensajePorDefecto) =>
		error?.response?.data?.mensaje || mensajePorDefecto;

	const completar = async (datosFormulario) => {
		setGuardando(true);
		try {
			await DetalleEnvioService.completarFormularioAdministrador(formularioSeleccionado.id, datosFormulario);
			message.success("El documento se ha completado correctamente.");
			setVisibleVisorFormulario(false);
			if (onCompletado) {
				onCompletado(formularioSeleccionado);
			}
		} catch (error) {
			message.error(mensajeError(error, "No se pudo completar el documento."));
		} finally {
			setGuardando(false);
		}
	};

	const onSubmit = (datosFormulario) => {
		Modal.confirm({
			title: "Completar documento",
			content: "El documento se completará a nombre del colaborador. ¿Desea continuar?",
			okText: "Completar",
			cancelText: "Cancelar",
			onOk: () => completar(datosFormulario),
		});
	};

	const onError = (errores) => {
		setErroresFormulario({ ...errores });
	};

	const onClickBtnCompletar = () => {
		handleSubmit(onSubmit, onError)();
	};

	const onClickBtnGuardarAvance = async () => {
		setGuardando(true);
		try {
			await DetalleEnvioService.guardarAvanceFormularioAdministrador(formularioSeleccionado.id, getValues());
			message.success("Se guardó el avance del documento.");
		} catch (error) {
			message.error(mensajeError(error, "No se pudo guardar el avance."));
		} finally {
			setGuardando(false);
		}
	};

	return (
		<div className="visor-pdf-header" style={{ borderBottom: "0px" }}>
			<div className="informacion">
				<FormOutlined className="icono" />
				<div className="texto">
					<span>
						<span className="periodo">{formularioSeleccionado?.colaborador?.nombreCompleto}</span>
						{" - "}
						<span className="documento">{formularioSeleccionado?.nombreDocumento}</span>
					</span>
					<span className="estado">
						<EstadoDocumento estado={formularioSeleccionado?.estadoVistaColaborador} />
					</span>
				</div>
			</div>

			<div className="acciones">
				{permiteGuardarAvance && (
					<Button
						icon={<SaveOutlined />}
						onClick={onClickBtnGuardarAvance}
						loading={guardando}
						disabled={loadingPdf}
						style={{ marginRight: "8px" }}
					>
						Guardar avance
					</Button>
				)}
				<Button type="primary" onClick={onClickBtnCompletar} loading={loadingPdf || guardando} disabled={loadingPdf}>
					Completar Documento
				</Button>
				<div className="visor-pdf-header-separador" />
				<Button type="text" className="cerrar" onClick={onClickBtnCerrar}>
					<CloseOutlined style={{ fontSize: "16px" }} />
				</Button>
			</div>
		</div>
	);
};

const EstadoDocumento = ({ estado }) => {
	if (estado === EstadoVistaColaborador.PENDIENTE) {
		return <Tag color="volcano">{estado}</Tag>;
	}
	return (
		<Tag color="green" icon={<CheckCircleOutlined />}>
			{estado}
		</Tag>
	);
};

export default Header;
